const _version = "3.8.5"
function version() {
    return _version
}
export default version
